import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { RoundPlusIcon, RoundMinusIcon } from '@/components/icons'
import { ChevronDown } from 'lucide-react'
import TableRowSkeleton from '@/components/common/TableRowSkeleton'
import Row from './Row'
import MetricsPicker from '../../MetricsPicker'
import { truncateText } from '@/lib/utils'

const CountriesTable = ({
    sortedCountries,
    countryStates,
    handleIncludeClick,
    handleExcludeClick,
    getSortIcon,
    handleSort,
    gdpLoading,
    selectedColumns,
    allMetrics,
    countryMetrics,
    formatMetricValue,
    handleMetricReplace,
    metricsDataLoading,
    allMetricsLoading,
}) => {
    const isLoading = gdpLoading || metricsDataLoading || allMetricsLoading

    return (
        <Table className="tw:[&_tbody_tr:nth-child(even)]:bg-[#142234]" fixedHeader={true} maxHeight="20rem">
            <TableHeader>
                <TableRow>
                    <TableHead className="tw:flex tw:items-center tw:justify-start tw:pl-3 tw:!gap-1">
                        <RoundPlusIcon className="tw:!w-6 tw:!h-6" />
                        <RoundMinusIcon className="tw:w-6 tw:h-6" />
                    </TableHead>
                    <TableHead className="tw:cursor-pointer tw:select-none tw:pl-1" onClick={() => handleSort('name')}>
                        <div className="tw:flex tw:items-center tw:gap-1">
                            <span>{truncateText('Country')}</span>
                            {getSortIcon('name')}
                        </div>
                    </TableHead>
                    <TableHead
                        className="tw:cursor-pointer tw:select-none tw:text-right tw:pr-1"
                        onClick={() => handleSort('gdp')}
                    >
                        <div className="tw:flex tw:items-center tw:gap-1 tw:justify-end">
                            <span>{truncateText('GDP')}</span>
                            {getSortIcon('gdp')}
                        </div>
                    </TableHead>
                    {selectedColumns.map((column, index) => (
                        <TableHead key={column.id} className="tw:text-[#899CBD] tw:!text-right tw:pr-3">
                            <MetricsPicker
                                allMetrics={allMetrics}
                                currentMetric={column}
                                onMetricSelect={(metric) => handleMetricReplace(index, metric)}
                            >
                                <button className="tw:flex tw:items-center tw:justify-end tw:gap-1 hover:tw:text-white tw:transition-colors tw:cursor-pointer tw:w-full">
                                    <span>{truncateText(column.name)}</span>
                                    <div className="tw:flex tw:items-center tw:gap-1">
                                        <ChevronDown className="tw:w-4 tw:h-4" />
                                    </div>
                                </button>
                            </MetricsPicker>
                        </TableHead>
                    ))}
                </TableRow>
            </TableHeader>
            {isLoading ? (
                <TableRowSkeleton rows={7} columns={3 + selectedColumns.length} showIcon={true} showCheckbox={false} />
            ) : (
                <TableBody>
                    {sortedCountries.map((country, index) => (
                        <Row
                            key={country.iso2}
                            country={country}
                            isLast={sortedCountries.length - 1 === index}
                            countryStates={countryStates}
                            handleIncludeClick={handleIncludeClick}
                            handleExcludeClick={handleExcludeClick}
                            selectedColumns={selectedColumns}
                            countryMetrics={countryMetrics}
                            formatMetricValue={formatMetricValue}
                        />
                    ))}
                </TableBody>
            )}
        </Table>
    )
}

export default CountriesTable
